import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MeetingActionComponent } from 'src/app/pages/operator/components/meeting-action/meeting-action.component';
import { IonicModule } from '@ionic/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MeetingStatesComponent } from './meeting-states/meeting-states.component';
import { CKEditorModule } from 'ckeditor4-angular';
import { ComponentsAdminModule } from '../../admin/componentsAdmin/components-admin.module';
import { HistoryComponent } from './history/history.component';
import { PipesModule } from '../pipes/pipes.module';
import { GeneralesComponentsModule } from 'src/app/generales-components/generales-components.module';
import { MeetingListComponent } from './meeting-list/meeting-list.component';
import { TranslateModule } from '@ngx-translate/core';
import { ObservationsComponent } from './observations/observations.component';
import { ConsumedServicesComponent } from './consumed-services/consumed-services.component';
import { BlockTurnsComponent } from './block-turns/block-turns.component';
import { NewAppointmentComponent } from './new-appointment/new-appointment.component';
import {
  OwlDateTimeModule,
  OwlNativeDateTimeModule,
} from '@danielmoncada/angular-datetime-picker';
import { ObservationsUserComponent } from './observations-user/observations-user.component';
import { PipeModule } from 'src/app/pipes/pipe-module.module';

const declarations = [
  MeetingStatesComponent,
  MeetingActionComponent,
  HistoryComponent,
  MeetingListComponent,
  ObservationsComponent,
  ConsumedServicesComponent,
  BlockTurnsComponent,
  NewAppointmentComponent,
  ObservationsUserComponent,
];

@NgModule({
  declarations: declarations,
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    ReactiveFormsModule,
    CKEditorModule,
    ComponentsAdminModule,
    PipesModule,
    GeneralesComponentsModule,
    TranslateModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    PipeModule,
  ],
  exports: declarations,
})
export class ActionsModule {}
